import { CustomFieldEntity } from './__generated__/FieldSettingsView.graphql';

export const DEFAULT_ENTITY: CustomFieldEntity = 'PROJECT';
export const CUSTOM_FIELDS_LIMIT = 10;
